export default __webpack_public_path__ + "static/media/2208.9e7e7ee8.png";